var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice-container" },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择类型", clearable: "" },
                      model: {
                        value: _vm.searchForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "type", $$v)
                        },
                        expression: "searchForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "会员中心公告", value: 0 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "任务规则", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "积分抵扣规则", value: 2 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "券膨胀规则", value: 3 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "小红书活动规则", value: 4 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "客诉券券发放规则", value: 5 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "客诉券券领取规则", value: 6 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.resetForm } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "margin-left": "auto" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-circle-plus-outline",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openDialog()
                        },
                      },
                    },
                    [_vm._v("新增公告")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          staticStyle: { "margin-top": "10px" },
          attrs: { shadow: "never" },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                "element-loading-text": "加载中...",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "iconUrl",
                  label: "图标",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-image", {
                          staticStyle: { width: "40px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.iconUrl,
                            fit: "contain",
                            "preview-src-list": [_vm.resPath + row.iconUrl],
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "content", label: "内容", "min-width": "250" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "type",
                  label: "类型",
                  width: "120",
                  formatter: _vm.typeFormatter,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: "操作",
                  width: "250",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDialog(row)
                                  },
                                },
                              },
                              [_vm._v("\n              编辑\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticClass: "drawer-container",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            size: "600px",
            "with-header": true,
            "before-close": _vm.resetDialogForm,
            direction: "rtl",
            "custom-class": "notice-drawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogFormRef",
              staticClass: "drawer-form",
              attrs: { model: _vm.dialogForm, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "类型",
                    rules: [
                      {
                        required: true,
                        message: "请选择类型",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择类型" },
                      model: {
                        value: _vm.dialogForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogForm, "type", $$v)
                        },
                        expression: "dialogForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "会员中心公告", value: 0 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "任务规则", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "积分抵扣规则", value: 2 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "券膨胀规则", value: 3 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "小红书活动规则", value: 4 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "客诉券券发放规则", value: 5 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "客诉券券领取规则", value: 6 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "内容",
                    rules: [
                      {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autosize: { minRows: 2, maxRows: 10 },
                      type: "textarea",
                      rows: "3",
                    },
                    model: {
                      value: _vm.dialogForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "content", $$v)
                      },
                      expression: "dialogForm.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.dialogForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "sort", $$v)
                      },
                      expression: "dialogForm.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.dialogForm.linkType,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogForm, "linkType", $$v)
                        },
                        expression: "dialogForm.linkType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "小程序", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "gaga社区", value: 1 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转地址" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入跳转链接" },
                    model: {
                      value: _vm.dialogForm.linkUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "linkUrl", $$v)
                      },
                      expression: "dialogForm.linkUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图标" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "",
                        "http-request": _vm.handlePictureUploadOne,
                        "on-remove": _vm.handleUploadRemove,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.fileList,
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸100px*100px,或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveNotice } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }